module.exports = __webpack_public_path__ + "static/FS-Barrier-1-5-2db4a25141bfff44f7ace0c807c10ebf.png";